import React,{useEffect,useState} from 'react';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { getOrgId } from '../../../utils/Token';
import axios from "../../../utils/fvAxios";
import { useNavigate } from "react-router-dom";
import EmployeeFirstLogin from './EmployeeFirstLogin';


export default function EmployeeSignature() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = React.useState(true);
    const [Signature, setSignature] = React.useState(false);
    const [data, setdata] = React.useState([]);
    const org_id = getOrgId();
    useEffect(() => {
        axios.get("Employee/GetVendorEmployeeQuizList?VendorId="+org_id +"&pageNumber=0&size=10."
        ).then((res) => {
          if (res.data.responseCode === 100) {
            setdata(res?.data.data?.employees)
            if(res?.data.data?.employees[0].isUserAcknowledged===true){
            
             navigate("/EmployeeQuizzes")
            }
            else{
                // navigate("/EmployeeFirstLogin")
                setSignature(true)
            }
            // const data = res?.data?.data;
            // setIntro(data)
            // setAlignment(data[0]?.value);
            // setSelectedValue(Alignments);
    
          }
          else {
            // setError(res.data.responseMessage);
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          setIsLoading(false);
        });
    
    
      }, []);

    


  return (
    <>
    <Backdrop
    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={isLoading}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
{Signature?<EmployeeFirstLogin Data={data}/>:""}
  </>
  )
}
